/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AcquisitionCandidateDetail from './pages/AcquisitionCandidateDetail';
import AcquisitionCandidates from './pages/AcquisitionCandidates';
import BusinessCustomers from './pages/BusinessCustomers';
import CreateInvoice from './pages/CreateInvoice';
import Dashboard from './pages/Dashboard';
import DataRoom from './pages/DataRoom';
import Deals from './pages/Deals';
import FollowUps from './pages/FollowUps';
import Home from './pages/Home';
import ImportData from './pages/ImportData';
import Integrations from './pages/Integrations';
import InternalProjects from './pages/InternalProjects';
import InvestmentAnalytics from './pages/InvestmentAnalytics';
import Investors from './pages/Investors';
import Invoices from './pages/Invoices';
import MyTasks from './pages/MyTasks';
import ProjectDetail from './pages/ProjectDetail';
import Projects from './pages/Projects';
import Reports from './pages/Reports';
import ResourceManagement from './pages/ResourceManagement';
import ScorecardTemplates from './pages/ScorecardTemplates';
import TaskDetail from './pages/TaskDetail';
import Tasks from './pages/Tasks';
import TeamDetail from './pages/TeamDetail';
import Teams from './pages/Teams';
import TimeTracking from './pages/TimeTracking';
import UserManagement from './pages/UserManagement';
import UserSettings from './pages/UserSettings';
import __Layout from './Layout.jsx';


export const PAGES = {
    "AcquisitionCandidateDetail": AcquisitionCandidateDetail,
    "AcquisitionCandidates": AcquisitionCandidates,
    "BusinessCustomers": BusinessCustomers,
    "CreateInvoice": CreateInvoice,
    "Dashboard": Dashboard,
    "DataRoom": DataRoom,
    "Deals": Deals,
    "FollowUps": FollowUps,
    "Home": Home,
    "ImportData": ImportData,
    "Integrations": Integrations,
    "InternalProjects": InternalProjects,
    "InvestmentAnalytics": InvestmentAnalytics,
    "Investors": Investors,
    "Invoices": Invoices,
    "MyTasks": MyTasks,
    "ProjectDetail": ProjectDetail,
    "Projects": Projects,
    "Reports": Reports,
    "ResourceManagement": ResourceManagement,
    "ScorecardTemplates": ScorecardTemplates,
    "TaskDetail": TaskDetail,
    "Tasks": Tasks,
    "TeamDetail": TeamDetail,
    "Teams": Teams,
    "TimeTracking": TimeTracking,
    "UserManagement": UserManagement,
    "UserSettings": UserSettings,
}

export const pagesConfig = {
    mainPage: "Dashboard",
    Pages: PAGES,
    Layout: __Layout,
};